import { render, staticRenderFns } from "./modal-reservation.vue?vue&type=template&id=6253d1fe&scoped=true"
import script from "./modal-reservation.vue?vue&type=script&lang=ts"
export * from "./modal-reservation.vue?vue&type=script&lang=ts"
import style0 from "./modal-reservation.vue?vue&type=style&index=0&id=6253d1fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6253d1fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6253d1fe')) {
      api.createRecord('6253d1fe', component.options)
    } else {
      api.reload('6253d1fe', component.options)
    }
    module.hot.accept("./modal-reservation.vue?vue&type=template&id=6253d1fe&scoped=true", function () {
      api.rerender('6253d1fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/modal-reservation.vue"
export default component.exports